<template>
	<div class="wrapper">
		<div class="load">
			<cube-loading v-if="isShowHint"></cube-loading>
			<div>{{hint}}</div>
		</div>
	</div>
</template>

<script>

    import {mapGetters,mapMutations} from "vuex";

    export default {
        data() {
            return {
                // 车牌号码
                plateNumber: "苏E16889",
                // 金额
                amount: 0.0,
                // 停车场名字
                plateName: "xx停车场",
                // 提示信息
                hint: "处理中",
                // 是否显示loading圈
                isShowHint: true,
                // 停车场Id
				parkId: undefined,
                parkinglotId: "",
                // 出口Id
                doorId: "",
                // 停车场信息
                parkinglotInfo: {},
                // 进出记录Id
                parkRecId: "",
                //出场时间
                outTime: undefined,
                // 订单号
                orderInfo: "",
                areaId: undefined,
                keyTopOrderNo: undefined,
                interfaceManner: undefined
            };
        },
        mounted() {
            let _this = this;
            if (this.$route.query.parkinglotId && this.$route.query.doorId) {
                this.parkinglotId = this.$encryptUtil.decrypt( _this.$route.query.parkinglotId);
                this.doorId = this.$encryptUtil.decrypt(_this.$route.query.doorId);
                console.log(this.parkinglotId, '停车场id');
                console.log(this.doorId,'出口id');
                
                
                this.$api.area.getAreaIdByDoorId(this.doorId).then(res => {
                    this.areaId = res.data.data.id;
                    this.setAreaId(res.data.data.id);
                    this.$api.area.getBasicConfig(this.areaId).then(res =>{
                        if (res.data.code == 200){
                            this.interfaceManner = res.data.data.interfaceManner;
                            this.setInterfaceManner(res.data.data.interfaceManner);
                            this.setIsCardPay(res.data.data.isCardPay);
                            this.getParkinglotInfo();
						} else {
                            this.getParkinglotInfo();
						}
					})
                })
            }
        },
        methods: {
            ...mapMutations({
                setOrderInfo: "SET_ORDER_INFO",
                setParkingId: "SET_PARKINGLOTID",
                setParkrec: "SET_PARKREC",
                setParkingInfo: "SET_PARKING_INFO",
                setDoorId: "SET_DOORID",
                setAreaId: "SET_AREA_ID",
                setOrderSnList: "SET_ORDERSNLIST",
				setInterfaceManner: "SET_INTERFACEMANNER",
				setKeyTopInImgUrl: "SET_KEYTOPINIMGURL",
				setIsCardPay: "SET_ISCARDPAY",
                setCouponFee: "SET_COUPONFEE",
                setKeyTopOrderNo: "SET_KEYTOPORDERNO",
                setParkRecId: "SET_PARKRECID",
                setAbParkId: "SET_ABPARKID",
				setOpenAD: "SET_OPENAD"
            }),
            showConfirm() {
                let that = this;
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-location",
                    title: this.plateName,
                    content:
                        "&nbsp;&nbsp;&nbsp;&nbsp;车牌为『" +
                        this.plateNumber +
                        "』的车主您好，您需要缴费" +
                        this.amount +
                        "元",
                    confirmBtn: {
                        text: "去缴费",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    },
                    cancelBtn: {
                        text: "取消",
                        active: false,
                        disabled: false,
                        href: "javascript:;"
                    },
                    onConfirm: () => {
                        if (that.parkRecId) {
                            if (!that.doorId || !that.amount || !that.parkinglotId || !this.areaId) {
                                this.$createDialog({
                                    type: "confirm",
                                    icon: "cubeic-alert",
                                    title: "提示",
                                    content: "请重新扫码",
                                    confirmBtn: {
                                        text: "确定",
                                        active: true,
                                        disabled: true,
                                        href: "javascript:;"
                                    },
                                }).show();
                                return
                            }
							this.$api.order
								.order({
									outDoor: that.doorId,
									totalPrice: parseFloat(that.amount).toFixed(2),
									parkRec: that.parkRecId,
									parkinglotId: that.parkId || that.parkinglotId,
									goodsType: 2,
									closed: 0,
									paymentPlatform: that.checkBrowser.id,
									areaId: that.areaId,
									outTime: that.outTime,
									paymentPlatformsn: this.keyTopOrderNo
								})
								.then(res => {
									console.log(res.data);
									if (res.data.code == 200) {
										this.orderInfo = res.data.data;
										this.setOrderInfo(that.orderInfo);
										this.setOrderSnList({});
										this.$router.push({name: "Order", params: {isEntry: true}});
									} else {
										this.showAlert(res.data.msg);
									}
								});
                        } else {
                            // 当前记录无ID
							this.$api.parkinglot.getRecordByPlateNo(this.plateNumber, this.parkinglotId, this.areaId).then(res => {
							    if (res.data.code === 200){
                                    if (res.data.data.id){
                                        this.setParkRecId(res.data.data.id);
                                        this.$api.order
                                            .order({
                                                outDoor: that.doorId,
                                                totalPrice: parseFloat(that.amount).toFixed(2),
                                                parkRec: res.data.data.id,
                                                parkinglotId: that.parkId || that.parkinglotId,
                                                goodsType: 2,
                                                closed: 0,
                                                paymentPlatform: that.checkBrowser.id,
                                                areaId: that.areaId,
                                                outTime: res.data.data.outTime,
                                                paymentPlatformsn: this.keyTopOrderNo
                                            })
                                            .then(res => {
                                                console.log(res.data);
                                                if (res.data.code == 200) {
                                                    this.orderInfo = res.data.data;
                                                    this.setOrderInfo(that.orderInfo);
                                                    this.setOrderSnList({});
                                                    this.$router.push({name: "Order", params: {isEntry: true}});
                                                } else {
                                                    this.showAlert(res.data.msg);
                                                }
                                            });
                                    } else {
                                        let data ={
                                            outDoor: that.doorId,
                                            totalPrice: parseFloat(that.amount).toFixed(2),
                                            parkinglotId: that.parkinglotId,
                                            goodsType: 2,
                                            closed: 0,
                                            paymentPlatform: that.checkBrowser.id,
                                            areaId: that.areaId,
                                            outTime: that.outTime,
                                            paymentPlatformsn: this.keyTopOrderNo,
                                            plateno: that.plateNumber
                                        };
                                        this.$api.parkinglot.noRecOrder(data).then(res =>{
                                            if (res.data.code == 200) {
                                                this.orderInfo = res.data.data;
                                                this.setOrderInfo(that.orderInfo);
                                                this.setOrderSnList({});
                                                this.$router.push({name: "Order", params: {isEntry: true}});
                                            } else {
                                                this.showAlert(res.data.msg);
                                            }
                                        })
                                    }
								} else {
                                    let data ={
                                        outDoor: that.doorId,
                                        totalPrice: parseFloat(that.amount).toFixed(2),
                                        parkinglotId: that.parkinglotId,
                                        goodsType: 2,
                                        closed: 0,
                                        paymentPlatform: that.checkBrowser.id,
                                        areaId: that.areaId,
                                        outTime: that.outTime,
                                        paymentPlatformsn: this.keyTopOrderNo,
                                        plateno: that.plateNumber
                                    };
                                    this.$api.parkinglot.noRecOrder(data).then(res =>{
                                        if (res.data.code == 200) {
                                            this.orderInfo = res.data.data;
                                            this.setOrderInfo(that.orderInfo);
                                            this.setOrderSnList({});
                                            this.$router.push({name: "Order", params: {isEntry: true}});
                                        } else {
                                            this.showAlert(res.data.msg);
                                        }
                                    })
								}
							});
                        }
                    },
                    onCancel: () => {
                        this.$createToast({
                            type: "warn",
                            time: 3000,
                            txt: "您取消了缴费"
                        }).show();
                        this.hint = "您取消了缴费，请重新扫码";
                        this.isShowHint = false;
                    }
                }).show();
            },
            parkFeeToast(res) {
                console.log(res,'获取是否可以无牌车');
                if (res.data.code == 200 && res.data.data) {
                    if (res.data.data.parkType == 2&&res.data.data.plateno=="无牌车") {
                        // 无车辆出场，跳转无牌车
                        this.$createDialog({
                            type: "confirm",
                            icon: "cubeic-alert",
                            title: "提示",
                            content: "未查询到当前有车辆出场，是否选择无牌车出场？",
                            confirmBtn: {
                                text: "确定",
                                active: true,
                                disabled: false,
                                href: "javascript:;"
                            },
                            onConfirm: () => {
                                this.$router.push({
                                    name: "Unlicensed",
                                    params: {
                                        parkinglotId: this.parkinglotId,
                                        doorId: this.doorId
                                    }
                                });
                            },
                            onCancel: () => {
                                this.hint = "未查询到当前有车辆出场";
                                this.isShowHint = false;
                            }
                        }).show();
                    } else if (res.data.data.parkType == 3) {
                        this.$createDialog({
                            type: "confirm",
                            icon: "cubeic-alert",
                            title: "提示",
                            content: "未查询到此车辆有入场记录",
                            confirmBtn: {
                                text: "确定",
                                active: true,
                                disabled: false,
                                href: "javascript:;"
                            },
                            onConfirm: () => {
                                // this.$createToast({
                                //   type: "warn",
                                //   time: 1000,
                                //   txt: "点击确认按钮"
                                // }).show();
                                this.hint = "未查询到此车辆有入场记录";
                                this.isShowHint = false;
                            },
                            onCancel: () => {
                                this.hint = "未查询到此车辆有入场记录";
                                this.isShowHint = false;
                            }
                        }).show();
                    } else {
                        this.keyTopOrderNo = res.data.data.keyTopOrderNo;
                        this.setKeyTopOrderNo(res.data.data.keyTopOrderNo);
                        this.plateNumber = res.data.data.plateno;
                        if (res.data.data.unpaidMoney) {
                            this.amount = parseFloat(res.data.data.unpaidMoney).toFixed(2);
                        }
                        this.parkRecId = res.data.data.id;
                        this.outTime = res.data.data.outTime;
                        this.setParkrec(res.data.data);
                        this.setParkingId(res.data.data.parkinglotId);
                        this.parkId = res.data.data.parkinglotId;
                        this.setKeyTopInImgUrl(res.data.data.inImgUrl);
                        this.setDoorId(this.doorId);
                        this.setCouponFee(parseFloat(res.data.data.parkCoupon || 0).toFixed(2));
                        this.showConfirm();
                        // this.getAreaId()
                    }
                } else {
                    // 当前没有车，跳转无牌车
                    this.$createDialog({
                        type: "confirm",
                        icon: "cubeic-alert",
                        title: "提示",
                        // content: res.data.msg!="操作成功"||"未查询到当前有车辆出场，是否选择无牌车出场？",
                        content: "未查询到当前有车辆出场，是否选择无牌车出场？",
                        confirmBtn: {
                            text: "确定",
                            active: true,
                            disabled: false,
                            href: "javascript:;"
                        },
                        onConfirm: () => {
                            this.$router.push({
                                name: "Unlicensed",
                                params: {
                                    parkinglotId: this.parkinglotId,
                                    doorId: this.doorId
                                }
                            });
                        },
                        onCancel: () => {
                            this.hint = "未查询到当前有车辆出场";
                            this.isShowHint = false;
                        }
                    }).show();
                }
			},
            getKeyTop () {
                this.$api.parkinglot.getDoorCode(this.doorId).then(res =>{
                    if (res.data.code === 200) {
                        let data = {
                            parkinglotId: this.parkinglotId,
                            ts: new Date().getTime(),
                            deviceCode: res.data.data.code
                        };
                        this.$api.area.getParkingPaymentInfo(data).then(res =>{
                            this.parkFeeToast(res)
                        })
					}
				})
			},
            getOutdoorRecord () {
                this.$api.parkinglot.getOutdoorRecord(this.doorId).then(res =>{
                    this.parkFeeToast(res)
				})
			},
            getParkinglotInfo() {
                if (this.parkinglotId && this.doorId) {
                    this.$api.parkinglot
                        .getParkinglotInfo(this.parkinglotId)
                        .then(res => {
                            console.log(res.data);
                            if (res.data.code == 200 && res.data.data) {
                                this.parkinglotInfo = res.data.data;
                                this.plateName = res.data.data.parkName;
                                this.setParkingInfo(res.data.data);
                                this.setOpenAD(res.data.data.isOpenAdvertising);

                                if (res.data.data.isOpenAdvertising == 1) {
                                    let data = {
                                        address: res.data.data.address,
                                        parkName: res.data.data.parkName
                                    };
                                    this.$api.parkinglot.getParkId(data).then(res =>{
                                        if (res.data.code === 200){
                                            this.setAbParkId(res.data.data.parkId);
                                        }
                                    });
								}

                            }
                            if (this.interfaceManner == 2) {
                                this.getKeyTop()
							} else {
                                this.getOutdoorRecord()
							}
                        })
                } else {
                    // 提示传递参数错误
                    this.$createDialog({
                        type: "confirm",
                        icon: "cubeic-alert",
                        title: "提示",
                        content: "参数错误",
                        confirmBtn: {
                            text: "确定",
                            active: true,
                            disabled: false,
                            href: "javascript:;"
                        },
                        onConfirm: () => {
                            this.hint = "参数错误";
                            this.isShowHint = false;
                        },
                        onCancel: () => {
                            this.hint = "参数错误";
                            this.isShowHint = false;
                        }
                    }).show();
                }
            },
            showAlert(value) {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-alert",
                    title: "提示",
                    content: value,
                    confirmBtn: {
                        text: "确定",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    }
                }).show();
                this.hint = value;
                this.isShowHint = false;
            },
            getAreaId(doorId) {
                this.$api.area.getAreaIdByDoorId(doorId).then(res => {
                    this.setAreaId(res.data.data.id);
                })
            }
        },
        components: {}
    };
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';

	.wrapper {
		position: relative;
		width: 100%;
		height: 100%;
		background: #ffffff;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		.load {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-bottom: 36px;

			div {
				margin-top: 24px;
			}
		}
	}
</style>
